import { Component, OnInit, Output, Input } from 'angular-ts-decorators';

import { uniq, concat, filter, includes, isArray } from 'lodash';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons';

import { EmailRegex } from '@core/app/scripts/services/email-regex';
import type { LocalStorage } from '@shared/app/scripts/services/local-storage';

/**
 * # Email List
 *
 * This component allows a user to input a list of emails. A function should be provided
 * to handle the actual sending of the emails to the backend. It can prefill from an array
 * of strings.
 *
 * # Example
 * <pre>
 *   <sw-email-list
 *    send-emails="$ctrl.sendEmail(emails)"
 *    sw-value="['email1@nl.nl']"
 *  ></sw-email-list>
 * </pre>
 */
@Component({
  selector: 'swEmailList',
  template: require('./sw-email-list.html').default,
})
export class SwEmailListComponent implements OnInit {
  @Input() swValue: string[];

  @Output() sendEmails: (value?: { emails: string[] }) => any;
  @Output() cancel: () => void;

  emails: string[];

  faPaperPlane = faPaperPlane;

  constructor(
    private emailRegex: EmailRegex,
    private $q: ng.IQService,
    private localStorage: LocalStorage,
  ) {
    'ngInject';
  }

  ngOnInit() {
    this.emails = this.swValue;
  }

  sendWrapper(emails: string[]) {
    let storedEmails: string[];

    try {
      storedEmails = JSON.parse(
        this.localStorage.getItem('swEmailListAutoComplete'),
      );
    } catch (error) {
      storedEmails = [];
    }

    if (isArray(storedEmails)) {
      let uniqEmails = uniq(concat(emails, storedEmails));
      this.localStorage.setItem(
        'swEmailListAutoComplete',
        JSON.stringify(uniqEmails),
      );
    } else {
      this.localStorage.setItem(
        'swEmailListAutoComplete',
        JSON.stringify(emails),
      );
    }

    this.sendEmails({ emails });
  }

  getAutoComplete($query) {
    let storedEmails: string[];

    try {
      storedEmails = JSON.parse(
        this.localStorage.getItem('swEmailListAutoComplete'),
      );
    } catch (error) {
      storedEmails = [];
    }

    if (!storedEmails) {
      return this.$q.when([]);
    }

    if (!$query) {
      return this.$q.when(storedEmails);
    }

    return this.$q.when(
      filter(storedEmails, (email: string) => {
        return includes(email, $query);
      }),
    );
  }
}
